import * as XLSX from "xlsx";
import {
  type ExportSheets,
  truncateWorksheetName,
} from "shared/components/pillar-table/export/build-export-sheets";

export const XLSX_CONTENT_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

type BuildExportXLSXBufferProps = {
  /** The main sheet and its nested-table sheets */
  sheets: ExportSheets;
};

/** Writes an export's sheets to one XLSX workbook, one tab per sheet. */
export const buildExportXLSXBuffer = ({
  sheets: { mainSheet, nestedSheets },
}: BuildExportXLSXBufferProps): Uint8Array => {
  const workBook = XLSX.utils.book_new();

  [mainSheet, ...nestedSheets].forEach((sheet) => {
    XLSX.utils.book_append_sheet(
      workBook,
      XLSX.utils.aoa_to_sheet(sheet.data),
      truncateWorksheetName(sheet.name),
    );
  });

  return XLSX.write(workBook, { type: "buffer", bookType: "xlsx" });
};
